import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

export default function ProductZoom({ zoom, onClose }) {
  useEffect(() => {
    if (!zoom) return;
    window.__lenis?.stop();
    document.body.style.overflow = "hidden";
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => {
      window.__lenis?.start();
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [zoom, onClose]);

  return (
    <AnimatePresence>
      {zoom && (
        <motion.div
          key="zoom-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
          data-testid="product-zoom-overlay"
          onClick={onClose}
          className="fixed inset-0 z-[80] flex flex-col items-center justify-center bg-black/92 backdrop-blur-md p-4"
        >
          <button
            onClick={onClose}
            data-testid="product-zoom-close-button"
            aria-label="Close full screen view"
            className="absolute right-4 top-4 rounded-full bg-white/10 p-2.5 text-white hover:bg-amber-500 hover:text-[#080C14] transition-colors"
          >
            <X size={22} />
          </button>
          <motion.img
            key={zoom.src}
            src={zoom.src}
            alt={zoom.name}
            initial={{ opacity: 0, scale: 0.94 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            onClick={(e) => e.stopPropagation()}
            className="max-h-[82vh] max-w-[92vw] object-contain rounded-xl shadow-[0_40px_120px_rgba(0,0,0,0.8)]"
          />
          {zoom.name && (
            <p className="mt-5 font-tech text-xs uppercase tracking-[0.25em] text-amber-300" data-testid="product-zoom-caption">
              {zoom.name}
            </p>
          )}
          <p className="mt-2 font-tech text-[10px] uppercase tracking-[0.2em] text-slate-500">
            Click anywhere or press Esc to close
          </p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
